import { ACTION_TYPES } from '../utils/Constants';

let initialState = {
    oauthUserDetails: {},
    userDetails: {},
    profileImage: {},
};

const UserReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.LOGIN_USER:
            return {
                ...state,
                oauthUserDetails: action.payload,
            };

        case ACTION_TYPES.GET_USER_INFORMATION:
            return {
                ...state,
                userDetails: action.payload,
            };

        case ACTION_TYPES.PROFILE_IMAGE:
            state = {
                ...state,
                profileImage: action.payload,
            };
            break;

        case ACTION_TYPES.LOGOUT_USER:
            return null;

        default:
            break;
    }
    return state;
};
export default UserReducer;
